import * as React from "react"

export default function NaMidiaTv({ width = 48, height = 48, fill = '#B25E8B', ...props }) {
    return (
        <svg style={{ width: width, height: height }} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M40 11.9999H28.828L33.414 7.41394L30.586 4.58594L24 11.1719L17.414 4.58594L14.586 7.41394L19.172 11.9999H8C5.794 11.9999 4 13.7939 4 15.9999V37.9999C4 40.2059 5.794 41.9999 8 41.9999H40C42.206 41.9999 44 40.2059 44 37.9999V15.9999C44 13.7939 42.206 11.9999 40 11.9999ZM8 37.9999V15.9999H40L40.004 37.9999H8Z" fill="#B25E8B"/>
        </svg>
    )
}